import React from 'react'
import GetOptions from '../../common/GetOptions'
import GetSimpleOptions from '../../common/GetSimpleOptions'

const SelectBox = ({value, text, data, keySuffux, simple=false, fieldProps}) => {
  return <div className="custom-select">
        <select {...fieldProps}>
            {
                simple ? <GetSimpleOptions data={data} keySuffux={keySuffux}/> :
                <GetOptions value={value} text={text} data={data} keySuffux={keySuffux}/>
            }
        </select>
    </div>
}

export default SelectBox